<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('inspector_teams.create.btnLabel') }}
    </base-button>

    <modal id="CreateInspectorTeam"
           :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg"
           showClose @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('inspector_teams.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('inspector_teams.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" v-on:submit.prevent="create()">
          <div class="row">
            <label class="col-sm-2 col-form-label">{{ $t('inspector_teams.form.name') }}</label>
            <div class="col-sm-8">
              <base-input
                type="name"
                name="name"
                v-validate="modelValidations.required"
                :error="getError('required')"
                v-model="team.name"
              >
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              class="my-4"
              @click="create()"
              :loading="updating"
            >{{ $t('inspector_teams.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
  import {BaseAlert, Modal} from 'src/components';
  import {Option, Select} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'create-inspector-team',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      BaseAlert
    },
    data() {
      return {
        modal: false,
        alert: false,
        team: {
          name: ''
        },
        modelValidations: {
          required: {
            required: true
          },
          email: {
            email: true
          },
          number: {
            numeric: true
          },
          url: {
            url: true
          },
          equalToSource: {
            required: true
          },
          equalToDest: {
            required: true,
            confirmed: 'equalToSource'
          }
        }
      }
    },
    computed: {
      ...mapState({
        loading: state => state.inspector_teams.loading,
        updating: state => state.inspector_teams.updating,
        error: state => state.inspector_teams.error,
        created: state => state.inspector_teams.created,
      }),
      getActionErrorDetails() {
        return this.error ? this.error.bodyText : null;
      }
    },
    methods: {
      ...mapActions(['CreateInspectorTeam', 'LoadInspectorTeams']),
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid);
        });
      },
      create: function () {
        this.CreateInspectorTeam(this.team).then(() => {
          if (this.error != null) {
            this.alert = true
            // got error, don't reset form
          } else {
            this.$notify({
              type: 'success',
              message: this.$t('inspector_teams.create.createdNotification', this.team),
              icon: 'tim-icons icon-alert-circle-exc'
            })
            this.$router.push({
              name: 'inspector_team',
              params: {id: this.created.id}
            }).catch(err => {
            })
            this.resetForm()
          }
        });
      },
      resetForm: function () {
        this.modal = false;
        this.alert = false;
        // resetting form
        this.team = {
          name: ''
        }

        // reset validation errors
        this.$validator.reset()
      }
    }
  }
</script>
